<script lang="ts" setup>
import type { CSSProperties } from 'vue';

import type { Category } from '~/models';

const props = defineProps<{
  category: Category;
}>();

const imageStyle = computed<CSSProperties>(() => ({
  backgroundImage: `url(${props.category.imageUrl || '/images/default-category.png'})`,
  backgroundSize: props.category.imageUrl ? 'cover' : 'contain'
}));

const nameStyle = computed<CSSProperties>(() => ({
  color: props.category.onlineFontColor,
  backgroundColor: props.category.onlineBgColor
}));

const offer = computed<string>(() => `'${props.category.offer}% off'`);
</script>

<template>
  <div class="category-item">
    <span
      v-if="category.offer"
      class="category-item__offer"
      data-test="offer"
    />

    <div
      class="category-item__image"
      :style="imageStyle"
      data-test="image"
    />

    <h3
      class="flex-1 flex items-center justify-center rounded font-semibold text-center uppercase p-1 overflow-hidden"
      :style="nameStyle"
      data-test="name"
    >
      <span class="truncate text-ellipsis">
        {{ category.name }}
      </span>
    </h3>
  </div>
</template>

<style lang="scss" scoped>
.category-item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  cursor: pointer;

  &__image {
    background-color: #ffffff50;
    border-radius: 4px;
    overflow: hidden;
    height: 7rem;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &__offer {
    position: absolute;
    top: 69px;
    left: -17px;
    transform: rotate(-45deg);
    transform-origin: top left;
    border-bottom: 22px solid white;
    border-left: 22px solid transparent;
    border-right: 22px solid transparent;
    height: 0;
    width: 122px;

    &::after {
      content: '';
      position: absolute;
      background: #00000050;
      top: 22px;
      left: -22px;
      height: 5px;
      border-radius: 0 0 5px 5px;
      width: 122px;
    }

    &::before {
      content: v-bind('offer');
      position: absolute;
      color: white;
      padding-block: 0;
      text-align: center;
      font-size: 0.75rem;
      font-weight: 900;
      top: 1px;
      left: -21px;
      text-transform: uppercase;
      transform-origin: top left;
      border-bottom: 20px solid red;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      height: 0;
      width: 120px;
    }
  }
}
</style>
